import axios from 'axios';
import config from '../config/config';

export const usuarioService = {
    get,
    post,
    put,
    deleteDetail
};
function get(apiEndpoint) {
    return axios.get(config.baseUrl + apiEndpoint, getOptions())
        .then((response) => {
            return response;
        }).catch((err) => {
            console.log(err.response);
            return err.response;
        })
}
function post(apiEndpoint, payload) {
    return axios.post(config.baseUrl + apiEndpoint, payload, getOptions())
        .then((response) => {
            return response;
        }).catch((err) => {
            console.log(err.response);
            return err.response;
        })
}

    function put(apiEndpoint, payload) {
        return axios.put(config.baseUrl + apiEndpoint, payload, getOptions())
            .then((response) => {
                return response;
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    }
    function deleteDetail(apiEndpoint) {
        return axios.delete(config.baseUrl + apiEndpoint, getOptions())
            .then((response) => {
                return response;
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    }
    function getOptions() {
        let options = {};
        //let authdata = window.btoa('gestorrp:gestor2414#');
        var token = localStorage.getItem('token');
        if (token === undefined) {
            token = 'gestorrp:gestor2414#';
        }
        let authdata = window.btoa(token);
        options.headers = { 'Authorization': 'Basic ' + authdata };
        return options;
    }

 